import {getUnixTime} from 'date-fns';

export default function nowUnixStamp(): number {
  return getUnixTime(new Date());
}